import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class TrendZoomController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    readonly item: any; // type to be determined

    static $inject = [];
}

export const wtTrendZoom: ComponentDefinition = {
    componentId: 'wtTrendZoom',
    controller: TrendZoomController,
    template: require('./trendZoom.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};
